namespace $.$$ {

	export class $shm_hitalama_map_widget_float_notebook2_adds_line extends $.$shm_hitalama_map_widget_float_notebook2_adds_line {

		body() {
			return this.add_types().length == 1
				? [ this.Button() ]
				: [ this.Pop_over() ]
		}

		button_click( next?: Event | null ) {
			if( next === undefined ) return null
			const [ type ] = this.add_types()
			if( type ) this.widget_add( type, next )
			return next
		}

		Menu(): $.$shm_hitalama_map_page_contextmenu {
			const obj = super.Menu() as $.$shm_hitalama_map_page_contextmenu & {
				add_types_limited?: boolean
			}
			obj.widget_add = ( type: string )=> {
				this.widget_add( type, null )
				obj.contextmenu_showed( false )
			}
			if( obj.add_types_limited ) return obj

			obj.item_ids = ()=> this.add_types().length > 0
				? this.add_types()
				: $.$shm_hitalama_map_page_contextmenu.prototype.item_ids.call( obj )
			obj.item_ids_top = ()=> this.add_types().length > 0
				? []
				: $.$shm_hitalama_map_page_contextmenu.prototype.item_ids_top.call( obj )
			obj.item_ids_top2 = ()=> this.add_types().length > 0
				? []
				: $.$shm_hitalama_map_page_contextmenu.prototype.item_ids_top2.call( obj )
			obj.add_types_limited = true
			return obj
		}

	}

}
